import { DEFAULT_HEADER_STATE, useSetHeaderContext } from '@/layouts/MainLayout/HeaderContext'
import { isComponentCatalogApp, isDagsterApp, isDatabricksApp } from '@/util/appTypes'
import { AppGeneric24Regular, Building24Regular, Document24Regular } from '@fluentui/react-icons'
import { IconDagsterOutline } from '@icons/IconDagsterOutline'
import { IconDatabricksOutline } from '@icons/IconDatabricksOutline'
import { useCurrentWorkspace } from './useCurrentWorkspace'
import { getAppLaunchPath } from '@/util/getAppLaunchPath'
import { OrganisationIcon } from '@/const'
import { useGetSearchParam } from '@/hooks/useGetSearchParams'
import { FlatSidebarMenu } from '@/components/ui/FlatSidebarMenu'
import { IconV2DocumentDirectoryOutline } from '@icons/IconV2DocumentDirectoryOutline'
import { IconV2ArchiveOutline } from '@icons/IconV2ArchiveOutline'
import { IconV2SettingsOutline } from '@icons/IconV2SettingsOutline'
import { IconV2FolderOutline } from '@icons/IconV2FolderOutline'
import { isPlatformAdmin, isProjectAdmin, isProjectLeader, isSuperUser } from '@/util'
import { useSessionStorage } from '@/hooks'
import { IconV2ClockOutline } from '@icons/IconV2ClockOutline'

const navigation = (appTypes: number, userId: number) => [
  { title: 'Details', Icon: AppGeneric24Regular, path: '.', visible: true },
  { title: 'Entities', Icon: Building24Regular, path: 'entities', visible: true },
  { title: 'Files', Icon: Document24Regular, path: 'files', visible: true },
  { title: 'File Manager', Icon: IconV2FolderOutline, path: 'file-manager', visible: true },
  { title: 'Data Templates', Icon: IconV2DocumentDirectoryOutline, path: 'file-templates', visible: true },
  { title: 'Data assets', Icon: IconV2ArchiveOutline, path: 'data-assets', visible: true },
  { title: 'Settings', Icon: IconV2SettingsOutline, path: 'settings', visible: true },
  { title: 'Databricks', Icon: IconDatabricksOutline, path: 'databricks', visible: isDatabricksApp(appTypes) },
  { title: 'Dagster', Icon: IconDagsterOutline, path: 'dagster', visible: isDagsterApp(appTypes) },
  {
    title: 'Event Scheduler',
    Icon: IconV2ClockOutline,
    path: 'event-scheduler',
    visible:
      Boolean(userId) &&
      (isProjectLeader(appTypes) || isProjectAdmin(appTypes) || isPlatformAdmin(appTypes) || isSuperUser(appTypes)),
  },
]

export function WorkspacesNavMenu({ sidebarOpen = true }: { sidebarOpen?: boolean }) {
  const [userId] = useSessionStorage('sub', 0)
  const {
    application,
    project,
    app_types: appTypes,
    app_key,
    app_id,
    project_id,
    organisation,
    organisation_id,
    workspaceId,
  } = useCurrentWorkspace()
  const returnPage = useGetSearchParam('returnPage')
  const applicationPath = getAppLaunchPath(
    appTypes,
    app_key,
    app_id,
    project_id,
    workspaceId,
    organisation_id,
    returnPage
  )

  useSetHeaderContext({
    ...DEFAULT_HEADER_STATE,
    title1: application,
    title2: project,
    titleUrl: applicationPath,
    titleNavigation: {
      current: 'workspace',
      target: applicationPath,
    },
    rightTitle: { text: organisation, icon: OrganisationIcon },
  })

  return <FlatSidebarMenu items={navigation(appTypes, userId)} sidebarOpen={sidebarOpen} />
}
